import React from "react";
import { Button, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	button: {
		padding: "2px 16px",
		fontSize: "14px",
	},
	buttonContainer: {
		display: "flex",
		gap: theme.spacing(1),
	},
}));

export default function LanguageSwitch({ languages, selectedLang, onChange, id }) {
	const classes = useStyles();

	return (
		<Box className={classes.buttonContainer}>
			{languages.map((lang) => (
				<Button
					id={`${id}-switch-lang-${lang.code}`}
					key={lang.code}
					variant="outlined"
					color={lang.code === selectedLang ? "primary" : "default"}
					onClick={() => onChange(lang.code)}
					className={classes.button}
				>
					{lang.label}{" "}
					{typeof lang.percentage === "number" &&
						lang.code !== "BASE" &&
						`(${lang.percentage}%)`}
				</Button>
			))}
		</Box>
	);
}
